import React, { useState } from "react"
import api from "../../api/axiosInstance"
import _ from "lodash"

import { Formik, Form } from "formik"
import { useNavigate } from "react-router-dom"

import schemaBuilder from "../../components/schemaBuilder"

// constants
import { ENTITY, DEF, ADD, EDIT } from "../../config/constants"

// hooks
import useGetFormDef from "../../hooks/useGetFormDef"

// comps
import FieldBuilder from "../../components/FieldBuilder"
import { LoaderSmall, LoaderSkeleton } from "../../components/Loaders"

// PR
import { Button } from "primereact/button"

export default function FormWrapper({ type, docValues }) {
  const navigate = useNavigate()

  const [msg, setMsg] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const params = {
    formId: ENTITY.MRF_ORDER,
    endpoint: DEF.FORM,
  }

  const [error, loading, def] = useGetFormDef(params)

  if (error) return <div>Err...</div>
  if (loading) return <LoaderSkeleton count={11} />

  const { fields, field_groups } = def
  const indexType = _.find(field_groups, ["value", "index"])

  const fieldsFilteredByGroup = _.reduce(
    fields,
    (acc, field) => {
      const fieldGroup = field.group || []
      if (_.isEmpty(fieldGroup)) return [...acc, field]
      if (_.includes(fieldGroup, 0) || _.includes(fieldGroup, indexType.id)) {
        return [...acc, field]
      }
      return acc
    },
    []
  )

  const handleFinalFieldDef = () => {
    if (type !== "edit") {
      return _.reduce(
        fieldsFilteredByGroup,
        (acc, field) => {
          if (field.condition === "edit-only") {
            return acc
          } else {
            return [...acc, field]
          }
        },
        []
      )
    }
    return fieldsFilteredByGroup
  }

  const finalFieldDef = handleFinalFieldDef()
  const [initialValues, validationSchema] = schemaBuilder(finalFieldDef)

  const handleSubmit = async (values) => {
    setSubmitting(true)
    const endpoint = () => {
      switch (type) {
        case "add":
          return ADD.MRF_ORDER
        case "edit":
          return EDIT.MRF_ORDER
      }
    }
    try {
      values.mrf_type = "index"
      const response = await api.post(`/${endpoint()}`, values)
      setSubmitting(false)
      if (response.data.status === "success") {
        return navigate("/index-file/list")
      }
      setMsg(response.data.msg)
    } catch (error) {
      setMsg(error)
      setSubmitting(true)
    }
  }

  const handleInitialValues = () => {
    switch (type) {
      case "add":
        return initialValues
      case "edit":
        return {
          ...initialValues,
          ...docValues,
        }
    }
  }

  return (
    <Formik
      initialValues={handleInitialValues()}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form style={{ margin: "15px 30px" }}>
          <div>{msg}</div>
          <FieldBuilder fields={finalFieldDef} />
          <Button type="submit" disabled={submitting}>
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  )
}
